Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Flickr = void 0;
var _react = _interopRequireDefault(require("react"));
var _generalObserver = require("../general-observer");
var _utils = require("./utils");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var Flickr = function Flickr(_ref) {
  var flickrLink = _ref.flickrLink;
  return /*#__PURE__*/_react["default"].createElement(_generalObserver.GeneralObserver, {
    onEnter: function onEnter() {
      return (0, _utils.handleFlickrLoad)();
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    "data-testid": "flickr",
    className: "flickr-embed-mdx",
    "data-flickr-embed": "true",
    "data-header": "true",
    "data-footer": "true"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: "https://live.staticflickr.com/".concat(flickrLink),
    width: "100%",
    height: "auto",
    alt: flickrLink
  })));
};
exports.Flickr = Flickr;